import * as React from 'react';
import {
  InfoOutlined,
  RestartAlt,
  Person,
  AccountBox,
  PersonAdd,
  Add,
  CorporateFare,
  Mail,
  Badge,
  KeyboardReturn,
  Contacts,
  AccountCircleOutlined,
  PersonAddAltOutlined,
  FolderShared,
} from '@mui/icons-material';
import {
  Box,
  Autocomplete,
  TextField,
  Popover,
  Typography,
  Chip,
  Avatar as MuiAvatar,
  AvatarProps as MuiAvatarProps,
  Tooltip,
  CircularProgress,
} from '@mui/material';
import {
  AvatarProps,
  AvatarsCell,
  AvatarsCellProps,
  getAlt,
  getContent,
  getTypography,
  stringToColour,
} from '..';
import {
  UseMutation,
  UseLazyQuery,
  UseQueryState,
} from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { useState } from 'react';
import { AlertDialog, AlertDialogProps } from '../../../dialogs';

export interface AvatarInputProps extends AvatarsCellProps {
  options?: (data?: any[]) => any[];
  lazyQuery?: UseLazyQuery<any>;
  queryParams?: any;
  subscription?: UseQueryState<any>;
  createMutation?: UseMutation<any>;
  deleteMutation?: UseMutation<any>;
  alertOnDelete?: (alert: AlertDialogProps) => void;
  disabled?: boolean;
  onCreate?: Function;
  hover?: boolean;
  reloadParent?: Function;
  force?: boolean;
}

export const AvatarsAutocompleteInput = (params: AvatarInputProps) => {
  const {
    options,
    data: originalData,
    lazyQuery,
    queryParams,
    subscription,
    createMutation,
    deleteMutation,
    alertOnDelete,
    disabled = false,
    onCreate,
    hover = false,
    force = false,
  } = params;
  const { data: avatarsCache } =
    (subscription && subscription(queryParams)) || {};
  const [reload] = (lazyQuery && lazyQuery()) || [() => {}];
  const [create] = (createMutation && createMutation()) || [() => {}];
  const [remove] = (deleteMutation && deleteMutation()) || [() => {}];
  const [anchorEl, setAnchorEl] =
    React.useState<HTMLButtonElement | null>(null);

  const [data, setData] = React.useState<AvatarProps[]>([
    ...(originalData || []),
  ]);

  React.useEffect(() => {
    if (force && originalData) {
      setData([...(originalData || [])]);
    }
  }, [force, originalData]);

  React.useEffect(() => {
    if (avatarsCache && Array.isArray(avatarsCache)) {
      setData(avatarsCache);
    }
  }, [avatarsCache]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [loading, setLoading] = React.useState<boolean>(false);
  return (
    <>
      {((data && data.length > 0) || hover) && (
        <>
          <Tooltip
            arrow
            placement="left-start"
            title={!disabled ? 'Click to add or modify assignees' : ''}
          >
            <Box
              onClick={(event: any) => {
                event.preventDefault();
                event.stopPropagation();
                if (!disabled) {
                  handleClick(event);
                }
              }}
            >
              {data && data.length > 0 ? (
                <AvatarsCell
                  {...{ params, data: data }}
                  tooltip={params.tooltip}
                />
              ) : (
                <PersonAddAltOutlined color="primary" />
              )}
            </Box>
          </Tooltip>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={(event: any) => {
              event.preventDefault();
              event.stopPropagation();
              handleClose();
            }}
            onClick={(event: any) => {
              event.preventDefault();
              event.stopPropagation();
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Box sx={{ p: 2, width: '250px' }}>
              <Autocomplete
                multiple
                disableClearable
                sx={{ width: '100%' }}
                options={(options && options(data)) || []}
                getOptionLabel={(option: any) => {
                  if (typeof option === 'string') {
                    return option;
                  } else {
                    return option?.label || option?.title || option?.name || '';
                  }
                }}
                value={data}
                renderInput={params => (
                  <TextField
                    {...params}
                    fullWidth
                    // variant="standard"
                    label={'Assign'}
                    multiline={true}
                    InputProps={{
                      ...(loading
                        ? {
                            ...params.InputProps,
                            endAdornment: (
                              <CircularProgress color="inherit" size={10} />
                            ),
                          }
                        : params.InputProps),
                    }}
                  />
                )}
                onChange={async (event: any, items: any) => {
                  if (items && Array.isArray(items) && items.length > 0) {
                    setLoading(true);
                    const newItem = items?.find(
                      (i: any) =>
                        // !data.find((j: any) => j.contact === i.contact)
                        !data?.find(
                          (j: any) =>
                            (i.contact === j.contact &&
                              j.group !== 'role' &&
                              i.group !== 'role') ||
                            (i.id === j.id &&
                              j.group === 'role' &&
                              i.group === 'role')
                        )
                    );
                    if (newItem && create && onCreate) {
                      await create(onCreate(newItem));
                      await reload(queryParams);
                    }
                    setLoading(false);
                  }
                }}
                // renderTags={(value: readonly string[], getTagProps: any) => {
                //   return value.map((option: any, index: number) => {
                //     const alt = getAlt(option);
                //     const bgcolor = stringToColour(alt);
                //     return (
                //       <Chip
                //         variant="outlined"
                //         color="secondary"
                //         icon={
                //           <MuiAvatar
                //             sizes="small"
                //             sx={{
                //               bgcolor,
                //               color: 'white',
                //               height: '20px',
                //               width: '20px',
                //               // ml: option?.variant
                //               //   ? `8px !important`
                //               //   : undefined,
                //             }}
                //             variant={option?.variant}
                //           >
                //             <span style={{ color: 'white', fontSize: '8px' }}>
                //               {getContent(option)}
                //             </span>
                //           </MuiAvatar>
                //         }
                //         label={
                //           getTypography(option)
                //           // option.role
                //           //   ? `${option.role.name}${
                //           //       option.firstname
                //           //         ? ' - ' +
                //           //           `${option.firstname} ${option.lastname}`
                //           //         : ''
                //           //     }`
                //           //   : option.name ||
                //           //     `${option.firstname} ${option.lastname}`
                //         }
                //         size="small"
                //         {...getTagProps({ index })}
                //         onDelete={async props => {
                //           if (alertOnDelete) {
                //             alertOnDelete({
                //               open: true,
                //               title: 'Are you sure?',
                //               content: `Unassign ${
                //                 option.role_r
                //                   ? `${option.role_r?.name} role`
                //                   : `${option.contact_r?.firstname} ${option.contact_r?.lastname}`
                //               }  from item?`,
                //               onConfirm: async (props: any) => {
                //                 setLoading(true);
                //                 if (remove && option.id) {
                //                   await remove(option.id);
                //                   await reload(queryParams);
                //                   getTagProps({ index }).onDelete(props);
                //                 }
                //                 setLoading(false);
                //               },
                //             });
                //           } else {
                //             setLoading(true);
                //             if (remove && option.id) {
                //               await remove(option.id);
                //               await reload(queryParams);
                //               getTagProps({ index }).onDelete(props);
                //             }
                //             setLoading(false);
                //           }
                //         }}
                //       />
                //     );
                //   });
                // }}
                // renderOption={(props: any, option: any) => {
                //   const alt = getAlt(option);
                //   const bgcolor = stringToColour(alt);
                //   return (
                //     <Box
                //       component="li"
                //       sx={{
                //         whiteSpace: 'nowrap',
                //         fontSize: '.8em',
                //         my: 0,
                //         py: 0,
                //       }}
                //       {...props}
                //     >
                //       <MuiAvatar
                //         sizes="small"
                //         sx={{
                //           bgcolor,
                //           // fontSize: '8px',
                //           color: 'white',
                //           height: '20px',
                //           width: '20px',
                //           mr: 1,
                //         }}
                //       >
                //         <span style={{ color: 'white', fontSize: '8px' }}>
                //           {getContent(option)}
                //         </span>
                //       </MuiAvatar>
                //       {`${option?.firstname || ''} ${option?.lastname || ''}`}
                //     </Box>
                //   );
                // }}
                {...renderAvatarGroups({
                  onDelete: async (
                    props: any,
                    option: any,
                    index: number,
                    getTagProps: any
                  ) => {
                    if (alertOnDelete) {
                      alertOnDelete({
                        open: true,
                        title: 'Are you sure?',
                        content: `Unassign ${
                          option.role_r
                            ? `${option.role_r?.name}${
                                option.contact_r?.firstname
                                  ? ` (${option.contact_r?.firstname} ${option.contact_r?.lastname})`
                                  : ''
                              } from item?${
                                option.contact_r?.firstname
                                  ? `\n\nNOTE: If you want to change the ${option.role_r?.name} for this project, you can do this in the team tabs.`
                                  : ''
                              }`
                            : `${option.contact_r?.firstname} ${option.contact_r?.lastname} from item?`
                        }`,
                        onConfirm: async (props: any) => {
                          setLoading(true);
                          if (remove && option.id) {
                            await remove(option.id);
                            await reload(queryParams);
                            getTagProps({ index }).onDelete(props);
                          }
                          setLoading(false);
                        },
                      });
                    } else {
                      setLoading(true);
                      if (remove && option.id) {
                        await remove(option.id);
                        await reload(queryParams);
                        getTagProps({ index }).onDelete(props);
                      }
                      setLoading(false);
                    }
                  },
                  hideEmail: true,
                })}
              />
            </Box>
          </Popover>
        </>
      )}
    </>
  );
};

export const renderAvatarGroups = ({
  role,
  displayRole,
  hideEmail,
  onDelete,
}: {
  role?: any;
  displayRole?: boolean;
  hideEmail?: boolean;
  onDelete?: (props: any, option: any, index: number, getTagProps: any) => void;
}) => ({
  renderTags: (value: readonly string[], getTagProps: any) => {
    return value.map((option: any, index: number) => {
      const alt = getAlt(option);
      const bgcolor = stringToColour(alt);
      return (
        <Chip
          variant="outlined"
          color="secondary"
          icon={
            <MuiAvatar
              sizes="small"
              sx={{
                bgcolor,
                color: 'white',
                height: '20px',
                width: '20px',
                // ml: option?.variant
                //   ? `8px !important`
                //   : undefined,
              }}
              variant={option?.variant}
            >
              <span style={{ color: 'white', fontSize: '8px' }}>
                {getContent(option)}
              </span>
            </MuiAvatar>
          }
          label={
            getTypography(option)
            // option.role
            //   ? `${option.role.name}${
            //       option.firstname
            //         ? ' - ' +
            //           `${option.firstname} ${option.lastname}`
            //         : ''
            //     }`
            //   : option.name ||
            //     `${option.firstname} ${option.lastname}`
          }
          size="small"
          {...getTagProps({ index })}
          onDelete={(props: any) =>
            onDelete && onDelete(props, option, index, getTagProps)
          }
        />
      );
    });
  },
  groupBy: (option: any) => {
    return option?.group?.toUpperCase() || ' ';
  },
  renderGroup: (params: any) => {
    return (
      <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }}>
        {params?.group && params?.group != ' ' && params?.group != '' && (
          <Box
            sx={{
              px: 1,
              backgroundColor: theme => theme.palette.secondary.main,
              borderRadius: '2px',
            }}
          >
            {params?.group.toUpperCase() === 'ROLE' ? (
              <Tooltip title={`ALL ROLES`}>
                <Box
                  component={'span'}
                  sx={{ fontWeight: 600, color: 'white' }}
                >
                  <AccountCircleOutlined sx={{ fontSize: '12px', mr: 1 }} />
                  ALL ROLES
                </Box>
              </Tooltip>
            ) : params?.group?.toUpperCase() !== role?.name?.toUpperCase() ? (
              params?.group?.toUpperCase() === 'PROJECT_CONTACT' ? (
                <Tooltip title={`PROJECT CONTACTS`}>
                  <Box
                    component={'span'}
                    sx={{ fontWeight: 600, color: 'white' }}
                  >
                    <FolderShared sx={{ fontSize: '12px', mr: 1 }} />
                    PROJECT CONTACTS
                  </Box>
                </Tooltip>
              ) : (
                <Tooltip title={`ALL CONTACTS`}>
                  <Box
                    component={'span'}
                    sx={{ fontWeight: 600, color: 'white' }}
                  >
                    <Contacts sx={{ fontSize: '12px', mr: 1 }} />
                    ALL CONTACTS
                  </Box>
                </Tooltip>
              )
            ) : (
              <Tooltip
                title={`Stakeholder: ${
                  typeof params.group === 'string'
                    ? params?.group?.toUpperCase()
                    : params?.group?.name?.toUpperCase()
                }`}
              >
                <Box
                  component={'span'}
                  sx={{ fontWeight: 600, color: 'white' }}
                >
                  <Badge sx={{ fontSize: '12px', mr: 1 }} />
                  {typeof params.group === 'string'
                    ? params?.group?.toUpperCase()
                    : params?.group?.name?.toUpperCase()}
                </Box>
              </Tooltip>
            )}
          </Box>
        )}
        {params.children}
      </Box>
    );
  },
  // renderOption: (props: any, option: any) => {
  //   const alt = getAlt(option);
  //   const bgcolor = stringToColour(alt);
  //   return (
  //     <Box
  //       component="li"
  //       sx={{
  //         whiteSpace: 'nowrap',
  //         fontSize: '.8em',
  //         my: 0,
  //         py: 0,
  //       }}
  //       {...props}
  //     >
  //       <MuiAvatar
  //         sizes="small"
  //         sx={{
  //           bgcolor,
  //           // fontSize: '8px',
  //           color: 'white',
  //           height: '20px',
  //           width: '20px',
  //           mr: 1,
  //         }}
  //       >
  //         <span style={{ color: 'white', fontSize: '8px' }}>
  //           {getContent(option)}
  //         </span>
  //       </MuiAvatar>
  //       {`${option.name || ''}${option?.firstname ? option.firstname+' ' : ''}${
  //         option?.lastname || ''
  //       }`}
  //     </Box>
  //   );
  // },
  renderOption: (props: any, option: any) => {
    const alt = getAlt(option);
    const bgcolor = stringToColour(alt);
    return (
      <Box
        component="li"
        sx={{ whiteSpace: 'nowrap', fontSize: '.8em', my: 0, py: 0 }}
        {...props}
      >
        {option?.addValue ? (
          <>
            <Tooltip title="Add Contact">
              <Add fontSize="inherit" sx={{ mr: 1 }} />
            </Tooltip>
            {option.title}
          </>
        ) : option?.type === 'organization' ? (
          <Box
            sx={{
              px: 1,
              // backgroundColor: 'lightgray',
              border: '2px solid lightgray',
              borderRadius: '2px',
            }}
          >
            {option.groupBy?.toUpperCase() !== role?.name?.toUpperCase() ? (
              <Tooltip title={`Organization: ${option?.name}`}>
                <Box component={'span'} sx={{ fontWeight: 600 }}>
                  <CorporateFare
                    sx={{ fontSize: '12px', mr: 1 }}
                    color="secondary"
                  />
                  {option?.name}
                </Box>
              </Tooltip>
            ) : (
              <Tooltip
                title={`Stakeholder: ${
                  typeof option.groupBy === 'string'
                    ? option.groupBy?.toUpperCase()
                    : option.groupBy?.name?.toUpperCase()
                }`}
              >
                <Box component={'span'} sx={{ fontWeight: 600 }}>
                  <Badge sx={{ fontSize: '12px', mr: 1 }} color="secondary" />
                  {option?.name}
                </Box>
              </Tooltip>
            )}
          </Box>
        ) : (
          <>
            {option.organization_r?.name && (
              <span>
                <KeyboardReturn
                  sx={{
                    fontSize: '12px',
                    mx: 1,
                    transform: 'scale(-1,1)',
                  }}
                  color="secondary"
                />
              </span>
            )}
            {(option.contact_r?.firstname ||
              option.contact_r?.lastname ||
              option.name) && (
              <>
                <MuiAvatar
                  sizes="small"
                  sx={{
                    bgcolor,
                    // fontSize: '8px',
                    color: 'white',
                    height: '20px',
                    width: '20px',
                    mr: 1,
                  }}
                  variant={
                    option.group?.toUpperCase() === 'ROLE'
                      ? 'square'
                      : 'circular'
                  }
                >
                  <span style={{ color: 'white', fontSize: '8px' }}>
                    {getContent(option)}
                  </span>
                </MuiAvatar>
                {`${
                  option.name
                    ? option.name
                    : option?.firstname || option?.lastname
                    ? `${option?.firstname ? option.firstname + ' ' : ''}${
                        option?.lastname || ''
                      }`
                    : ''
                }`}
              </>
              // <span>
              //   {option.group?.toUpperCase() === 'ROLE' ? (
              //     <AccountCircleOutlined
              //       sx={{
              //         fontSize: '12px',
              //         mr: 1,
              //       }}
              //       color="secondary"
              //     />
              //   ) : (
              //     <Person
              //       sx={{
              //         fontSize: '12px',
              //         mr: 1,
              //       }}
              //       color="secondary"
              //     />
              //   )}
              //   {`${option?.name || ''} ${option.contact_r?.firstname || ''} ${
              //     option.contact_r?.lastname || ''
              //   }`}
              // </span>
            )}
            {option.contact_r?.email && !hideEmail && (
              <i>
                <u>
                  <Mail
                    sx={{
                      fontSize: '12px',
                      mr: 1,
                      ml:
                        option.contact_r?.firstname ||
                        option.contact_r?.lastname
                          ? 1
                          : 0,
                    }}
                    color="secondary"
                  />
                  <small>{option.contact_r?.email}</small>
                </u>
              </i>
            )}
            {!option?.groupBy ? (
              <>
                {option?.role && (
                  <i>
                    <Badge sx={{ fontSize: '12px', mx: 1 }} color="secondary" />
                    <small>{option?.role_r?.name}</small>
                  </i>
                )}
              </>
            ) : (
              <>
                {!!displayRole && option?.role && (
                  <i>
                    <Badge sx={{ fontSize: '12px', mx: 1 }} color="secondary" />
                    <small>{option?.role_r?.name}</small>
                  </i>
                )}
                {option?.organization_r?.name && (
                  <b>
                    <CorporateFare
                      sx={{ fontSize: '12px', mx: 1 }}
                      color="secondary"
                    />

                    <small>{option?.organization_r?.name?.toUpperCase()}</small>
                  </b>
                )}
              </>
            )}
          </>
        )}
      </Box>
    );
  },
});
